<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="#BCBBBB"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
      stroke="#BCBBBB"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 15C10.5178 15 10.9375 14.5803 10.9375 14.0625C10.9375 13.5447 10.5178 13.125 10 13.125C9.48223 13.125 9.0625 13.5447 9.0625 14.0625C9.0625 14.5803 9.48223 15 10 15Z"
      fill="#BCBBBB"
    />
    <path
      d="M9.99997 11.25V10.625C10.4326 10.625 10.8555 10.4967 11.2153 10.2563C11.575 10.016 11.8554 9.67433 12.021 9.27462C12.1865 8.87491 12.2298 8.43507 12.1454 8.01074C12.061 7.58641 11.8527 7.19663 11.5468 6.89071C11.2408 6.58478 10.8511 6.37644 10.4267 6.29203C10.0024 6.20763 9.56256 6.25095 9.16285 6.41651C8.76314 6.58208 8.4215 6.86246 8.18113 7.22219C7.94076 7.58192 7.81247 8.00485 7.81247 8.4375"
      stroke="#BCBBBB"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
